import PropTypes from 'prop-types'
import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import {
  ListItem
} from 'components/List'
import { getStatusIconName } from 'utils/status'
import { useColor } from 'utils/colors'

const CardStatus = React.forwardRef(({
  name,
  role,
  color,
  isSelected,
  ...props
}, ref) => {
  const statusColor = useColor(color)

  return (
    <ListItem
      ref={ref}
      active={isSelected}
      icon={
        <KanBoIcon
          fixedWidth
          name={getStatusIconName(role)}
          style={{
            color: statusColor,
          }}
        />
      }
      {...props}
    >
      {name}
    </ListItem>
  )
})

export class Status extends React.Component {
  static propTypes = {
    cardStatuses: PropTypes.array.isRequired,
    status: PropTypes.object,
    onStatusClick: PropTypes.func,
  }

  render () {
    const {
      cardStatuses,
      status,
      onStatusClick,
    } = this.props

    return (
      <ul className='list-group'>
        {cardStatuses.map(cardStatus => {
          const isSelected = status.id === cardStatus.id

          const onClick = () => {
            if (onStatusClick) onStatusClick(cardStatus)
          }

          return (
            <CardStatus
              key={cardStatus.id}
              name={cardStatus.name}
              role={cardStatus.role}
              color={cardStatus.color}
              isSelected={isSelected}
              onClick={onClick}
            />
          )
        })}
      </ul>
    )
  }
}

export default Status
